export default __webpack_public_path__ + "static/media/vaccine-bro.566bd9f6.svg";